import { render, staticRenderFns } from "./SO_order_summary.vue?vue&type=template&id=4ccf7c0f&"
import script from "./SO_order_summary.vue?vue&type=script&lang=js&"
export * from "./SO_order_summary.vue?vue&type=script&lang=js&"
import style0 from "./SO_order_summary.vue?vue&type=style&index=0&id=4ccf7c0f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports